import { Colors } from "@/enums/Colors";
import { Box, Button, Dialog, DialogContent, Typography, styled } from "@mui/material";

const StyledButton = styled(Button)(({}) => ({
  width: "290px",
  height: "27px",
  textTransform: "none",
  padding: "0 8px",
  borderRadius: "4px",
  "&.dont-show-button": {
    color: Colors.BUTTON_HOVER_PURPLE,
    backgroundColor: Colors.WHITE,
    border: `1px solid ${Colors.BUTTON_HOVER_PURPLE}`,
  },
  "&.got-it-button": {
    color: Colors.WHITE,
    backgroundColor: Colors.BUTTON_HOVER_PURPLE,
  },
}));

const StyledDialog = styled(Dialog)(({}) => ({
  position: "absolute",
  left: "75%",
  bottom: "73%",
  width: "25%",
  "& .MuiPaper-root": {
    boxShadow: `0 0 10px ${Colors.LIGHT_GRAY}`,
    borderRadius: "12px",
    "& .MuiDialogContent-root": {
      padding: "16px 24px",
    },
  },
}));

const Container = styled(Box)(({}) => ({
  "&.content-container": {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  "&.button-container": {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    gap: "8px",
  },
}));

const Text = styled(Typography)(({}) => ({
  "&.modal-title": {
    fontWeight: "bold",
    fontSize: "18px",
  },
  "&.modal-content": {
    color: Colors.LIGHT_GRAY_8A8E93,
    fontSize: "14px",
    paddingBottom: "8px",
  },
}));

interface Props {
  showArchiveModal: boolean;
  handleOnClose: () => void;
  dontShowAgainClick: () => void;
}

export const ArchiveConversationModal = ({ showArchiveModal, handleOnClose, dontShowAgainClick }: Props) => {
  return (
    <StyledDialog hideBackdrop open={showArchiveModal} onClose={handleOnClose}>
      <DialogContent>
        <Container className="content-container">
          <Text className="modal-title">Archive</Text>
          <Text className="modal-content">You can view archived chats here</Text>
          <Container className="button-container">
            <StyledButton className="dont-show-button" onClick={dontShowAgainClick}>
              Don't show this again
            </StyledButton>
            <StyledButton className="got-it-button" onClick={handleOnClose}>
              Got it
            </StyledButton>
          </Container>
        </Container>
      </DialogContent>
    </StyledDialog>
  );
};
